import axios from 'axios';
import analytics from 'shared/utility/analytics';

export const getSettings = (callback) => {
  axios({
    method: 'get',
    url: '/looptijdrente/tool-settings',
  }).then((response) => {
    const { uaCode } = response.data;
    analytics.init('G-PT1EDB8SF2', uaCode);
    callback(response.data);
  }).catch((err) => { throw err; });
};

export default getSettings;
